<template>
  <b-col>
    <b-button
        data-test-path="close-button"
        variant="plm-tertiary"
        :disabled="disabled"
        :class="!readOnly ? 'button-max-long' : 'size-button'"
        @click.stop="clickOnButton"
    >
      <font-awesome-icon icon="caret-left" class="fa-xl" />
      <span ref="label" class="d-none d-md-inline pl-1" v-if="showLabel">
        {{!readOnly? tr('button.cancel','Cancel') : tr('close','Close')}}
      </span>
    </b-button>
  </b-col>
</template>

<script>

import {CLOSE_WITHOUT_SAVE_LABEL} from '@/components/navbar/ButtonLabel';
import tr from "../../utils/Tr";


export default {
  name: "CloseButton",

  methods: {
    tr,

    clickOnButton() {
      this.$emit("close");
    },
  },

  props: {
    disabled: {default: false},
    close:            Function,
    readOnly:         {type: Boolean, default: true},
    showLabel: {default: true}
  },

}
</script>


